<template>
  <div class="container">
    <div style="margin-bottom: 20px">
      <el-date-picker
        v-model="timeRange"
        type="datetimerange"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        :default-time="['00:00:00', '23:59:59']"
        style="position: relative; top: 1px">
      </el-date-picker>
      <el-input prefix-icon="el-icon-search"
                clearable
                v-model="searchText"
                style="width: 200px; margin-left: 10px;"
                placeholder="技师">
      </el-input>
      <el-button style="margin-left: 10px" @click="search">查询</el-button>
      <el-button @click="exportData"><a :href="exportUrl">导出</a></el-button>
    </div>
    <el-table :data="technicianList_" v-loading="loading || $store.state.data.loading.DispatchableProcedure"
              header-cell-class-name="table-head"
              class="table-border">
      <el-table-column label="技师 | 工序" align="center">
        <template #default="{row, $index}">
          <div>
            {{row.technicianName}}
            <template v-if="$index < technicianList_.length - 1">
              <label style="margin: 0 6px">|</label>
              {{row.technicianType | valueName('TechnicianType')}}
            </template>
          </div>
        </template>
      </el-table-column>
      <el-table-column v-for="procedure in $store.state.data.DispatchableProcedure" :key="procedure.id"
                       :label="procedure.name" align="center">
        <template #default="{row}">
          {{!row.procedureMap[procedure.id]?0:parseFloat(row.procedureMap[procedure.id]).toFixed(1)}}
          <template v-if="row.procedureMap[procedure.id]">
            <label v-if="procedure.technicianType === 'SHEET_METAL'">(时)</label>
            <label v-else>(面)</label>
          </template>
        </template>
      </el-table-column>
      <el-table-column label="技师总计" align="center">
        <template #default="{row, $index}">
          <template v-if="$index < technicianList_.length - 1">
            {{row.total}}
            <template v-if="row.total">
              <label v-if="row.technicianType === 'SHEET_METAL'">(时)</label>
              <label v-else>(面)</label>
            </template>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { technicianWorkHours } from '@/utils/request'

  export default {
    name: 'TechnicianWorkStatistics',
    data () {
      return {
        loading: false,
        searchText: null,
        technicianList: [],
        timeRange: null,
        pickerOptions: {
          disabledDate (time) {
            return time.getLocalDays() > new Date().getLocalDays()
          }
        }
      }
    },
    created () {
      this.$store.dispatch('data/kvList', 'DispatchableProcedure')
      this.search()
    },
    methods: {
      search () {
        this.loading = true
        const begTimeSec = this.timeRange ? this.timeRange[0].getTime() / 1000 : null
        const endTimeSec = this.timeRange ? this.timeRange[1].getTime() / 1000 : null
        technicianWorkHours(begTimeSec, endTimeSec).then(response => {
          this.technicianList = response.data
        }).finally(() => {
          this.loading = false
        })
      },
      exportData () {
        window.location.href = this.exportUrl
      }
    },
    computed: {
      technicianList_ () {
        let list = [...this.technicianList]
        if (this.searchText) {
          list = this.technicianList.filter(item => item.technicianName.indexOf(this.searchText) > -1)
        }
        const lastItem = {
          technicianName: '工序总计',
          procedureMap: {},
          total: 0
        }
        for (const item of list) {
          for (const procedureId in item.procedureMap) {
            let value = lastItem.procedureMap[procedureId]
            if (!value) value = 0
            lastItem.procedureMap[procedureId] = value += item.procedureMap[procedureId]
            lastItem.total += value
          }
        }
        list.push(lastItem)
        return list
      },
      exportUrl () {
        let url = this.$baseUrl + 'api/downloadTechnicianWorkHours?'
        if (this.timeRange) {
          url += '&begTime=' + this.timeRange[0].getTime() / 1000
          url += '&endTime=' + this.timeRange[1].getTime() / 1000
        }
        if (this.searchText) {
          url += '&searchText=' + this.searchText
        }
        return url
      }
    },
    watch: {
      timeRange () {
        this.search()
      }
    }
  }
</script>

<style lang="scss" scoped>
  /deep/ th {
    height: 50px;
  }
</style>
